// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__3rqfD","YotascaleLogo":"Logo_YotascaleLogo__2DxuU","YotascaleLogoTagline":"Logo_YotascaleLogoTagline__1y8ui"};